import { render } from "./ContrastSwitcher.vue?vue&type=template&id=b8d48a08&scoped=true&ts=true"
import script from "./ContrastSwitcher.vue?vue&type=script&lang=ts"
export * from "./ContrastSwitcher.vue?vue&type=script&lang=ts"

import "./ContrastSwitcher.vue?vue&type=style&index=0&id=b8d48a08&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8d48a08"]])

export default __exports__